export enum Role {
    ReadOnly = 'readonly',
    CustomerAdmin = 'customeradmin',
    PartnerAdmin = 'partneradmin',
    SuperAdmin = 'superadmin'
}